module.exports = __webpack_public_path__ + "gn.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/gn.svg
// module id = 574
// module chunks = 0